import React, { forwardRef, useEffect, useState } from 'react';
import './Invoice.css';
import { Product, Products } from '../models/product';
import { OrderType } from '../pages/orders/view';

type InvoiceType = {
    businessName: string,
    businessAddress: string

}
const Invoice = React.forwardRef((props: any, ref: any) => {

    const [invoiceData, setInvoiceData] = useState<InvoiceType>({
        businessName: 'Autopjese Ardhmeria',
        businessAddress: 'Rilindja Kombetare, Malisheve'
    })

    const [order, setOrder] = useState<OrderType>({
        id: null,
        userId: null,
        fullName: null,
        totalAmount: null,
        totalDiscount: null,
        orderDate: null,
        status: 0,
        items: [],
    });


    const calculateSubtotal = () => {
        return order.items.reduce((acc, item) => acc + item?.quantity * item?.unitPrice, 0);
    };

    const calculateTotal = () => {
        return calculateSubtotal();
    };

    useEffect(() => {

        if(props.order){
            setOrder(props.order)
        }

        console.log("props order", props.order)
    }, [])

    return (
        <div className="container my-5 invoice-container" ref={ref}>
            <div className="row mb-4">
                <div className="col-6">
                <img src="https://ardhmeria-ks.com/b2b/assets/Ardhmeria_emblem.png" className="header-logo" />
                    {/* <h2 className="mt-4">{invoiceData.businessName}</h2> */}
                    <p className='mt-3'>{invoiceData.businessAddress}</p>
                </div>
                <div className="col-6 text-end">
                    <h4>Fature</h4>
                    <p>Numri i fatures #: {order.id}</p>
                    <p>Data: {order.orderDate}</p>
                    {/* <p>Due Date: {invoiceData.dueDate}</p> */}
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-6">
                    <h5>Faturuar tek:</h5>
                    <p>{order.fullName}</p>
                </div>
            </div>

            {order && (
                <>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Produkti</th>
                                <th>Sasia</th>
                                <th>Cmimi</th>
                                <th>Totali</th>
                            </tr>
                        </thead>
                        <tbody>
                            {order.items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item?.productName}</td>
                                    <td>{item?.quantity}</td>
                                    <td>€{item?.productPrice?.toFixed(2)}</td>
                                    <td>€{(item?.quantity * item?.productPrice)?.toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="row">
                        <div className="col-6"></div>
                        <div className="col-6 text-end">
                            <p>Subtotali: €{order?.totalAmount}</p>
                            <p>Zbritja: €{order?.totalDiscount}</p>
                            <h5>Totali: €{order?.totalAmount - order?.totalDiscount}</h5>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
});

export default Invoice;
